import React from "react";
import { useTranslation } from "react-i18next";

import { Box } from "components";
import StressTransition from "./charts/StressTransition";

import FactorsAndEffect from "./charts/FactorsAndEffect";
import ChangesInStress from "./charts/ChangesInStress";

const StressCheckTotal: React.FC = () => {
  const { t }: any = useTranslation("translation", {
    keyPrefix: "stress-check",
  });

  return (
    <Box title={t("stress-total")} padding="16px 16px 32px">
      <StressTransition />
      <FactorsAndEffect />
      <ChangesInStress />
    </Box>
  );
};
export default StressCheckTotal;
